import { cx } from '@linaria/core';
import { label, borderClearer, errorMessage, wrapper, modifiers } from './atom.input-border.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function InputBorder(props) {
  return /*#__PURE__*/jsxs("label", {
    id: props.id,
    className: cx(wrapper, props.className, props.active && modifiers.active.className, !props.value && modifiers.empty.className, props.invalid && modifiers.invalid.className, props.readOnly && modifiers.readOnly.className, props.disabled && modifiers.disabled.className),
    ref: props.ref,
    children: [props.children, (props.label || props.value === "") && /*#__PURE__*/jsx("span", {
      className: label,
      children: props.label
    }), props.label && /*#__PURE__*/jsx("span", {
      className: borderClearer,
      "aria-hidden": true,
      children: props.label
    }), /*#__PURE__*/jsx("span", {
      className: cx(errorMessage),
      children: props.errorMessage && `* ${props.errorMessage}`
    })]
  });
}

export { InputBorder };
//# sourceMappingURL=atom.input-border.js.map
